/**
 * @author       sammy.dowds@zumper.com (Sammy Dowds)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { CREATE_PROPERTY_BASEPATH, CreatePropertyPageTypeRoutes } from '@zcode/manage-routes'
import { routesConstants } from '@zcode/zumper-routes'

interface Props {
  isProUser?: boolean
}
export const getPostListingLink = ({ isProUser }: Props) => {
  const url = isProUser
    ? (`${CREATE_PROPERTY_BASEPATH}/${CreatePropertyPageTypeRoutes.LOCATION}` as const)
    : routesConstants.ADVERTISE_URL
  return url
}
